import React, { useRef, useState } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import MainApp from './MainApp';
import { Scrollbars } from 'react-custom-scrollbars-2';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './css/theme.css';
import './css/footer.css';
import './css/galery.css';
import './css/index.css';
import './css/news.css';
import './css/customScrollbar.css';
import {AuthProvider} from "./context/AuthContext";

function App() {
    const scrollbarRef = useRef(null);
    const [isNavbarOpen, setIsNavbarOpen] = useState(false);

    const closeNavbar = () => {
        setIsNavbarOpen(false);
    };

    return (
        <Router>
            <AuthProvider>
                <Scrollbars
                    ref={scrollbarRef}
                    style={{ height: '100vh', overflowX: 'hidden' }}
                    renderView={({ style, ...props }) => (
                        <div
                            {...props}
                            style={{ ...style, marginRight: 0, marginBottom: 0 }}
                            className="sp-scroll-view"
                        />
                    )}
                    renderTrackVertical={(props) => <div {...props} className="scrollbar-track" />}
                    renderThumbVertical={(props) => <div {...props} className="scrollbar-thumb" />}
                    onScroll={() => {
                        if (isNavbarOpen) {
                            closeNavbar();
                        }
                    }}
                >
                    <MainApp
                        scrollbarRef={scrollbarRef}
                        isNavbarOpen={isNavbarOpen}
                        setIsNavbarOpen={setIsNavbarOpen}
                        closeNavbar={closeNavbar}
                    />
                </Scrollbars>
            </AuthProvider>
        </Router>
    );
}

export default App;
